import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'
import { dictionaries } from '../utils/dictionaries'
import { decodeFromDictionary } from '../types'

type Props = {
  data: any
}

const rows = [
  { period: '近7天', key: 'xyp_cpl0009' },
  { period: '近30天', key: 'xyp_cpl0011' },
  { period: '近90天', key: 'xyp_cpl0012' },
  { period: '近180天', key: 'xyp_cpl0013' },
]

export default function RecentApplicationTable({ data }: Props) {
  const theme = useTheme()

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        近期贷款申请
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>统计周期</Table.Th>
            <Table.Th style={{ width: '60%' }}>贷款机构数</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.key}>
              <Table.Td>{row.period}</Table.Td>
              <Table.Td>{decodeFromDictionary(dictionaries, row.key, data?.[row.key])}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
